import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[...slug]/page.js");
